module.exports = __webpack_public_path__ + "static/img/shared-hosting.6d38748.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shared-hosting.png
// module id = h6IB
// module chunks = 0